<template>
  <div class="csv-errors">
    <v-card class="error-card" elevation="2">
      <v-card-text>
        <div class="error-header">
          <div class="error-info">
            <v-icon color="error" class="mr-2">mdi-alert-circle-outline</v-icon>
            <span class="error-title">Errores de validación</span>
          </div>
          <v-chip color="error" variant="tonal" size="small">
            {{ errors.length }} error(es)
          </v-chip>
        </div>

        <v-divider class="my-4"></v-divider>

        <v-alert type="warning" variant="tonal" class="mb-4" density="compact">
          {{ message }}
        </v-alert>

        <div class="error-table-wrapper">
          <table class="error-table">
            <thead>
              <tr>
                <th>Fila</th>
                <th>Columna</th>
                <th>Valor recibido</th>
                <th>Motivo del error</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(err, index) in paginatedErrors" :key="index">
                <td class="text-center">{{ err.row }}</td>
                <td class="col-name">{{ getColumnLabel(err.column) }}</td>
                <td class="value-cell">
                  <code>{{ truncateValue(err.value) }}</code>
                </td>
                <td class="message-cell">{{ err.message }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="totalPages > 1" class="pagination-wrapper mt-4">
          <v-pagination v-model="currentPage" :length="totalPages" size="small" total-visible="5"></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  errors: { type: Array, default: () => [] },
  message: { type: String, default: 'Se encontraron errores en el archivo. Corrige los errores e intenta nuevamente.' },
})

const PER_PAGE = 15
const currentPage = ref(1)

const totalPages = computed(() => Math.ceil(props.errors.length / PER_PAGE))

const paginatedErrors = computed(() => {
  const start = (currentPage.value - 1) * PER_PAGE
  return props.errors.slice(start, start + PER_PAGE)
})

const getColumnLabel = (col) => {
  const labels = {
    nombre: 'Nombre',
    correo_electronico: 'Correo electrónico',
    contrasena: 'Contraseña',
    rol: 'Rol',
    grupo_principal_id: 'Grupo principal',
    grupos_secundarios_ids: 'Grupos secundarios',
    archivo: 'Archivo',
    encabezados: 'Encabezados',
    general: 'General',
  }
  return labels[col] || col
}

const truncateValue = (val) => {
  if (val === null || val === undefined) return '-'
  const str = String(val)
  return str.length > 80 ? str.substring(0, 80) + '...' : str
}
</script>

<style scoped>
.error-card {
  border-radius: 16px !important;
  border-left: 4px solid #ef4444 !important;
}

.error-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.error-info {
  display: flex;
  align-items: center;
}

.error-title {
  font-weight: 600;
  color: #dc2626;
  font-size: 1.1rem;
}

.error-table-wrapper {
  overflow-x: auto;
}

.error-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.error-table th {
  background: #fef2f2;
  color: #991b1b;
  font-weight: 600;
  padding: 10px 12px;
  text-align: left;
  border-bottom: 2px solid #fecaca;
  white-space: nowrap;
}

.error-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #fef2f2;
  color: #1e293b;
  vertical-align: top;
}

.error-table tr:hover td {
  background: #fff5f5;
}

.col-name {
  font-weight: 500;
  white-space: nowrap;
}

.value-cell code {
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.8rem;
  color: #dc2626;
  word-break: break-all;
}

.message-cell {
  color: #475569;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
}
</style>
